import ImageIcon from '../ImageIcon';
import Pagination, { PaginationItem, PaginationList } from '../Pagination';
import { PageInfo } from '@/helpers/PaginationHelper';
import { Link } from 'gatsby';
import queryString from 'query-string';
import React, { FC, useMemo } from 'react';

interface BasicPaginationProps extends PageInfo {
  hash?: string;
  anchor?: string;
}

const BasicPagination: FC<BasicPaginationProps> = ({
  firstOfGroup,
  lastOfGroup,
  prevGroup,
  nextGroup,
  currentPage,
  totalPageCount,
  keyword,
  baseUri,
  hash = ``,
  ...props
}) => {
  // keyword가 있다면, 쿼리스트링으로 페이징 처리
  const getPageUri = (page: number) => {
    if (keyword) {
      return `/?${queryString.stringify({
        currentPage: page,
        keyword,
      })}${props.anchor || ``}`;
    }
    // keyword가 없을때, 1페이지는 기존페이지
    if (page === 1) {
      return `${props.anchor || ``}`;
    }
    return `/page/${page}${props.anchor || ``}`;
  };

  const hashString = useMemo(() => (hash ? `#${hash}` : ``), [hash]);

  return (
    <Pagination align="center">
      <PaginationList>
        {currentPage !== 1 && (
          <PaginationItem>
            <Link to={`${baseUri}${getPageUri(1)}${hashString}`}>
              <ImageIcon name="pagination-first" />
            </Link>
          </PaginationItem>
        )}
        {prevGroup < firstOfGroup && (
          <PaginationItem>
            <Link to={`${baseUri}${getPageUri(prevGroup)}${hashString}`}>
              <ImageIcon name="pagination-prev" />
            </Link>
          </PaginationItem>
        )}
        {Array.from({ length: lastOfGroup - firstOfGroup + 1 }).map((_, i) => {
          const page = firstOfGroup + i;
          return (
            <PaginationItem key={page} active={page === currentPage}>
              <Link to={`${baseUri}${getPageUri(page)}${hashString}`}>
                {page}
              </Link>
            </PaginationItem>
          );
        })}
        {nextGroup > lastOfGroup && (
          <PaginationItem>
            <Link to={`${baseUri}${getPageUri(nextGroup)}${hashString}`}>
              <ImageIcon name="pagination-next" />
            </Link>
          </PaginationItem>
        )}
        {currentPage !== totalPageCount && (
          <PaginationItem>
            <Link to={`${baseUri}${getPageUri(totalPageCount)}${hashString}`}>
              <ImageIcon name="pagination-last" />
            </Link>
          </PaginationItem>
        )}
      </PaginationList>
    </Pagination>
  );
};

export default BasicPagination;
